import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import OuterLink from '../../../atoms/OuterLink'

const Item = styled.li`
  border-left: 1px solid ${({ theme }) => theme.palette.border.light};
  padding: 0 8px;
  &:first-child {
    border: 0;
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
`

const ItemLink = styled(Link)`
  color: ${({ theme }) => theme.palette.font.link};
  font-size: 8px;
  text-decoration: none;
  vertical-align: super;
`

const ItemOuterLink = styled(OuterLink)`
  color: ${({ theme }) => theme.palette.font.link};
  font-size: 8px;
  text-decoration: none;
  vertical-align: super;
`

export default function BottomMenuItem({ text, to }: { text: string; to: string }) {
  const Component = /^\/.+/.test(to) ? ItemLink : ItemOuterLink

  return (
    <Item>
      <Component to={to}>{text}</Component>
    </Item>
  )
}
